import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-especialistas-documentacion',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './especialistas-documentacion.component.html',
  styleUrl: './especialistas-documentacion.component.css',
})
export class EspecialistasDocumentacionComponent implements OnInit {
  specialists: any[] = [];
  filteredSpecialists: any[] = [];
  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 5;
  totalPages: number = 1;
  selectedRole: string = '2'; // Valor predeterminado: Especialista en Documentación

  constructor(
    private http: HttpClient,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.cargarEspecialistas();
  }

  cargarEspecialistas(): void {
    const apiUrl = `${environment.apiUrl}/rol-usuario?id_rol=${this.selectedRole}`;
    this.http.get<any[]>(apiUrl).subscribe(
      (data) => {
        //console.log(data);
        this.specialists = data;
        this.filteredSpecialists = data;
        this.updatePagination();
      },
      (error) => {
        Swal.fire({
          title: 'Error',
          text:
            error.error.message || 'No se pudieron obtener los especialistas.',
          icon: 'error',
        });
      }
    );
  }

  onRoleChange(): void {
    this.currentPage = 1; // Reiniciar la paginación
    this.cargarEspecialistas(); // Recargar los especialistas según el rol seleccionado
  }

  applyFilter(): void {
    this.filteredSpecialists = this.specialists.filter(
      (specialist) =>
        //filtrar por nombre, correo o id
        specialist.usuario.correo
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase()) ||
        `${specialist.usuario.nombres} ${specialist.usuario.apellidos}`
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase()) ||
        specialist.usuario.codigo_documento
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
    );
    this.currentPage = 1;
    this.updatePagination();
  }

  updatePagination(): void {
    this.totalPages = Math.ceil(
      this.filteredSpecialists.length / this.pageSize
    );
  }

  getPaginatedSpecialists(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredSpecialists.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    this.currentPage = page;
  }

  goBack(): void {
    this.router.navigate(['/main']);
  }

  goToCreateSpecialist(): void {
    this.router.navigate(['/create-especialista-documentacion'], {
      queryParams: { id_rol: this.selectedRole },
    });
  }

  goToSpecialistDetail(specialist: any): void {
    this.router.navigate(['/especialista-documentacion'], {
      queryParams: {
        id_rol_usuario: specialist.id_rol_usuario,
        id_rol: this.selectedRole,
      },
    });
  }

  eliminarEspecialista(id: number): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.delete(`${environment.apiUrl}/rol-usuario/${id}`).subscribe(
          () => {
            Swal.fire(
              'Eliminado',
              'El especialista ha sido eliminado.',
              'success'
            );
            this.cargarEspecialistas(); // Refrescar la lista
          },
          (error) => {
            Swal.fire('Error', error.error.message || 'No se pudo eliminar el especialista.', 'error');
          }
        );
      }
    });
  }
}
